import React from 'react';
import classes from './PlanRecommendation.module.scss';

const planRecommendation = (props) => {
  return (
    <div className={classes.PlanRecommend}>
      <div className={classes.Title}>We Recommend: </div>
      <div className={classes.planTitle}>
        {props.planRecommendationSelected.plan}
      </div>
      {props.planRecommendationSelected.slug !== 'eightyBallpark' ? (
        <div className={classes.priceRange}>
          Price Range {props.planRecommendationSelected.priceRange}
          <br />
          <strong>{props.planRecommendationSelected.avgSavings}</strong> average
          savings off single-game ticket price
          <p className={classes.blurb}>
            {props.planRecommendationSelected.blurb}
            {props.planRecommendationSelected.subBlurb && (
              <>
                <br />
                <span>{props.planRecommendationSelected.subBlurb} </span>
              </>
            )}
          </p>
        </div>
      ) : (
        <div className={classes.priceRange}>
          Price: {props.planRecommendationSelected.priceEnd}
          <br />
          Only <strong>
            {props.planRecommendationSelected.priceStart}
          </strong>{' '}
          per game
          <p className={classes.blurb}>
            {props.planRecommendationSelected.blurb}
            {props.planRecommendationSelected.subBlurb && (
              <>
                <br />
                <span>{props.planRecommendationSelected.subBlurb} </span>
              </>
            )}
          </p>
        </div>
      )}
      <div className={classes.benefitsWrapper}>
        <div className={classes.benefitTitle}>Benefits</div>

        <div className={classes.benefitListWrapper}>
          <div className={classes.benefitsListItem}>
            <div className={classes.benefitsListItemTitle}>Exclusivity</div>
            <ul>
              {props.planRecommendationSelected.exclusivity.map(
                (res, index) => (
                  <li key={index}>{res}</li>
                )
              )}
            </ul>
          </div>
          <div className={classes.benefitsListItem}>
            <div className={classes.benefitsListItemTitle}>Savings</div>
            <ul>
              {props.planRecommendationSelected.savings.map((res, index) => (
                <li
                  className={
                    res === 'FREE 50% Bonus Credit' ? classes.highlight : ''
                  }
                  key={index}
                >
                  {res}
                </li>
              ))}
            </ul>
          </div>
          <div className={classes.benefitsListItem}>
            <div className={classes.benefitsListItemTitle}>Convenience</div>
            <ul>
              {props.planRecommendationSelected.convenience.map(
                (res, index) => (
                  <li key={index}>{res}</li>
                )
              )}
            </ul>
          </div>
        </div>
      </div>

      {props.planRecommendationSelected.slug === 'fiveClassic' ? (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://purchase.tickets.com/buy/MLBEventInfo?agency=WSHN_FLEX103&orgid=17&pid=8800391"
        >
          <div className={classes.greenButton}>Choose my games</div>
        </a>
      ) : (
        <div
          className={classes.greenButton}
          onClick={() => props.onClickShowScheduleSelection()}
        >
          {props.planRecommendationSelected.slug === 'eightyBallpark'
            ? 'Buy Now'
            : 'Show me my seats'}
        </div>
      )}
      <p className={classes.covid19}>
        {/* *50% Bonus Credit calculated based on the amount paid towards qualifying
        new 2021 ticket plans on or before December 15, 2020, less all associated
        fees. For 50% Bonus Credit program terms & conditions, please visit{' '}
        <a
          href="http://www.nationals.com/bonusterms"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.nationals.com/bonusterms
        </a>
        .
        <br />
        <br /> */}
        All 2021 access, benefits, promotions, seating locations, and events
        (including, without limitation, location, dates and times) are subject
        to change without notice based on the ongoing developments of the
        COVID-19 pandemic.
      </p>
    </div>
  );
};

export default planRecommendation;
